import { Label } from "@mui/icons-material";
import { ServiceTagRequest, ServiceTagResponse } from "../../models/ServiceTag";
import { BadgeProps, BaseBadge } from "./BaseBadge";


export function ServiceTagBadge(props: BadgeProps<ServiceTagRequest | ServiceTagResponse>) {
    const content = props.textOverride ?? props?.ressource?.name
    return <BaseBadge {...props} content={content ? <>{content}</> : undefined} icon={Label} />
}